import React, {useState, useRef} from "react";
import {Title, Text} from "../theme/theme";
import { IoIosClose, IoIosOpen } from "react-icons/io";
import AnimateHeight from 'react-animate-height';
import Draggable  from 'react-draggable'; // Both at the same time


export const ArtifexContainer = ({title, icon, children})=>{
    

    return    <div   
            style={{border: "2px solid yellow", 
            width: "99%", 
            height: "99%",
            background: "yellow",
        }}>
    <div style={{padding: "20px", background: "black"}} >
      <Title>
        <span className="react-grid-dragHandleExample">
            {icon} &nbsp;  
            {title}
        </span>        
        </Title>
    </div>
    
    <div style={{backgroundColor: "yellow"}}>
      <div style={{padding: "20px"}}>
        <Text inverted>
          {children}
        </Text>
      </div>
    </div>
  </div>
}

export default ArtifexContainer;